import React from 'react';
import PropTypes from 'prop-types';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';

import Typography from '@mui/material/Typography';

import WarningIcon from '@mui/icons-material/Warning';


import DropZone from 'components/Shared/DropZone';
import LoadingButton from 'components/Shared/LoadingButton';


import { red } from '@mui/material/colors';



const AddMemoDialog = ({ open, onClickCancel, onClickSave, onChange, reclamationId, text, isAdding, sauvegardable, memoWarning }) => (
    <Dialog
        fullWidth
        maxWidth={'md'}
        open={open}>
        <DialogTitle>
            Ajouter un mémo au dossier après-vente {reclamationId}
        </DialogTitle>

        <DialogContent>

            <Stack mt={1} spacing={1}>

                {memoWarning && (
                    <Typography>
                        <WarningIcon style={{ color: red[500], marginRight: '8px' }} />
                        {memoWarning}
                    </Typography>
                )}



                <TextField
                    id="text"
                    name="text"
                    label="Mémo"
                    placeholder="Mémo"
                    multiline
                    margin="normal"
                    value={text}
                    onChange={onChange}
                    autoFocus
                />

                <DropZone id="fichiersIds" name="fichiersIds" onChange={onChange} />

            </Stack>
        </DialogContent>

        <DialogActions>
            <Button
                disabled={isAdding}
                onClick={onClickCancel}
                color="primary"
            >
                Annuler
            </Button>
            <LoadingButton
                disabled={!sauvegardable || isAdding}
                onClick={onClickSave}
                label="Enregistrer"
                pending={isAdding}
            />


        </DialogActions>
    </Dialog>
);

AddMemoDialog.propTypes = {
    onClickCancel: PropTypes.func.isRequired,
    onClickSave: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    reclamationId: PropTypes.number.isRequired,
    text: PropTypes.string.isRequired,
    sauvegardable: PropTypes.bool.isRequired,
    isAdding: PropTypes.bool.isRequired
};

export default AddMemoDialog;